var exports = {
  "k": "container__GswVpq",
};

module.exports = exports;
